<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon @click="editTermPopup = true" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
    <!-- <feather-icon @click="confirmDeleteRecord" icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" /> -->
    <feather-icon
      @click="confirmRemoveTermFromSetRecord"
      icon="DeleteIcon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      v-if="params.api.setId !== ''"
    />

    <vs-popup :active.sync="editTermPopup" title="Edit Term">
      <div class="popup-input" v-if="termData">
        <p class="mb-1 font-semibold">Name</p>
        <vs-input v-model="termData.term" class="mb-3 w-full" />

        <p class="mb-1 font-semibold">Description</p>
        <vs-textarea v-model="termData.definition" height="100px" class="mb-3 w-full" />

        <p class="mb-1 font-semibold">Status</p>
        <div class="flex items-center mb-3">
          <vs-radio v-model="termData.status" vs-name="status" vs-value="active" class="mr-4">Active </vs-radio>
          <vs-radio v-model="termData.status" vs-name="status" vs-value="disabled" class="mr-4">Disabled </vs-radio>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editTermPopup: false,
      termData: null,
    };
  },
  methods: {
    update_termData(data) {
      const pl = data;

      if (pl.term === undefined || pl.definition === undefined) {
        return this.$vs.notify({
          title: 'Failed to update term',
          text: 'Please provide a Term Name',
          color: 'danger',
          position: 'top-right',
        });
      }

      this.$vs.loading();

      this.$http
        .patch(`study/term/${this.params.data.id}`, pl)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Updated Term Successfully',
              text: 'Term has been updated.',
              color: 'success',
              position: 'top-right',
            });
            return true;
          }
        })
        .catch((exception) => {
          this.$vs.loading.close();

          let error = 'An unknown error occurred while updating this term';
          if (exception.response) {
            error = exception.response.data.error.description;
          }

          return this.$vs.notify({
            title: 'Failed to update term',
            text: error,
            color: 'danger',
            position: 'top-right',
          });
        });
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',

        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this term.',
        accept: this.deleteRecord,
        acceptText: 'Delete',
      });
    },
    deleteRecord() {
      this.$vs.loading();

      this.$http
        .delete(`study/term/${this.params.data.id}`)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.params.loadProductBuffer();

            return this.$vs.notify({
              color: 'success',
              title: 'Term Deleted',
              text: 'You have successfully deleted this term',
              position: 'top-right',
            });
          }

          this.showError({ response });
        })
        .catch(this.showError);
    },
    confirmRemoveTermFromSetRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',

        title: 'Confirm Remove Term From Set',
        text: 'Please confirm you want to remove this term from the filtered set',
        accept: this.removeTermFromSetRecord,
        acceptText: 'Confirm',
      });
    },
    removeTermFromSetRecord() {
      this.$vs.loading();

      this.$http
        .patch(`study/set/${this.params.api.setId}/terms`, { removeIds: [this.params.data.id] })
        .then((response) => {
          this.$vs.loading.close();
          if (response.status === 200) {
            this.params.loadProductBuffer();

            return this.$vs.notify({
              color: 'success',
              title: 'Term Removed From Set',
              text: 'You have successfully removed this term from the filtered set',
              position: 'top-right',
            });
          }
          this.showError({ response });
        })
        .catch(this.showError);
    },
    showError(exception) {
      this.$vs.loading.close();

      let error = 'An unknown error occurred while archive this term';
      if (exception.response) {
        error = exception.response.data.message;
      }

      return this.$vs.notify({
        title: 'Failed to archive term',
        text: error,
        color: 'danger',
        position: 'top-right',
      });
    },
  },
  created() {
    this.termData = {
      term: this.params.data.term,
      definition: this.params.data.definition,
      status: this.params.data.status,
    };
  },
  watch: {
    editTermPopup(val) {
      if (!val) this.update_termData(this.termData);
    },
  },
};
</script>
